import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import About from './pages/About';
import Contact from './pages/Contact';
import SmoothScroll from './components/SmoothScroll';
import Home from './pages/Home';
import NavMenu from './components/NavMenu';
import Projects from './pages/Projects';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <Router>
        <SmoothScroll>
          <NavMenu />
          <Switch>
            <Route path="/" exact>
              <Home />
            </Route>
            <Route path="/about" exact>
              <About />
            </Route>
            <Route path="/projects" exact>
              <Projects />
            </Route>
            <Route path="/contact" exact>
              <Contact />
            </Route>
          </Switch>
          <Footer />
        </SmoothScroll>
      </Router>
    </>
  );
}
